import * as actionTypes from "./actionTypes";


export const submitInvoice = (data) => {
  return {
    type: actionTypes.SUBMIT_INVOICE,
    data
  };
};

export const submitInvoiceSuccess = (data) => {

  return {
    type: actionTypes.SUBMIT_INVOICE_SUCCESS,
    data
  };
};


export const submitInvoiceFail = () => {
  return {
    type: actionTypes.SUBMIT_INVOICE_FAIL
  };
};


export const getDocumentDetail = (data) => {
  return {
    type: actionTypes.GET_TAX_DOCUMENT_DETAIL,
    data
  };
};

export const getDocumentDetailSuccess = (data) => {

  return {
    type: actionTypes.GET_TAX_DOCUMENT_DETAIL_SUCCESS,
    data
  };
};


export const getDocumentDetailFail = () => {
  return {
    type: actionTypes.GET_TAX_DOCUMENT_DETAIL_FAIL
  };
};


export const cancelSubmission = (data) => {
  return {
    type: actionTypes.CANCEL_SUBMISSION,
    data
  };
};

export const cancelSubmissionSuccess = (data) => {

  return {
    type: actionTypes.CANCEL_SUBMISSION_SUCCESS,
    data
  };
};


export const cancelSubmissionFail = () => {
  return {
    type: actionTypes.CANCEL_SUBMISSION_FAIL
  };
};



export const validateTIN = (id, data) => {
  return {
    type: actionTypes.VALIDATE_TIN,
    id,
    data
  };
};

export const validateTINSuccess = () => {

  return {
    type: actionTypes.VALIDATE_TIN_SUCCESS
  };
};


export const validateTINFail = () => {
  return {
    type: actionTypes.VALIDATE_TIN_FAIL
  };
};




export const addTaxpayer = (data) => {
  return {
    type: actionTypes.ADD_TAXPAYER,
    data
  };
};

export const addTaxpayerSuccess = () => {

  return {
    type: actionTypes.ADD_TAXPAYER_SUCCESS
  };
};


export const addTaxpayerFail = () => {
  return {
    type: actionTypes.ADD_TAXPAYER_FAIL
  };
};

export const setDefaultTaxpayer = (id, data) => {
  return {
    type: actionTypes.SET_DEFAULT_TAXPAYER,
    id,
    data
  };
};

export const setDefaultTaxpayerSuccess = () => {

  return {
    type: actionTypes.SET_DEFAULT_TAXPAYER_SUCCESS
  };
};


export const setDefaultTaxpayerFail = () => {
  return {
    type: actionTypes.SET_DEFAULT_TAXPAYER_FAIL
  };
};


export const loadTaxSettings = (data) => {
  return {
    type: actionTypes.LOAD_TAX_SETTINGS,
    data
  };
};

export const loadTaxSettingsSuccess = (data) => {

  return {
    type: actionTypes.LOAD_TAX_SETTINGS_SUCCESS,
    data
  };
};


export const loadTaxSettingsFail = () => {
  return {
    type: actionTypes.LOAD_TAX_SETTINGS_FAIL
  };
};
